(function () {
  var MAP = { black:'#111111', white:'#f4f2ee', ivory:'#f5f2ed', cream:'#efe6d6', 'off-white':'#efe6d6', grey:'#8c8c8c', gray:'#8c8c8c', silver:'#c0c0c0', charcoal:'#36393b', brown:'#6b4226', coffee:'#4b3226', tan:'#b08968', camel:'#b88a5a', beige:'#d8c3a5', khaki:'#a39a6b', olive:'#6b6b3a', green:'#3d5a40', army:'#4b5320', teal:'#1d6f7c', peacock:'#1d6f7c', blue:'#2f4f8f', navy:'#1f2a44', sky:'#8ab4d8', red:'#9b1c1c', wine:'#5b1a2a', burgundy:'#5b1a2a', pink:'#e8b4c0', purple:'#6a4c93', lilac:'#b9a4d6', mauve:'#a98ba3', orange:'#d9822b', yellow:'#e2c14a', gold:'#b79b6c', rose:'#d98ca0', taupe:'#8b7d6b', mushroom:'#a79b8e' };
  function hex(h) { return [parseInt(h.substr(1, 2), 16), parseInt(h.substr(3, 2), 16), parseInt(h.substr(5, 2), 16)]; }
  function mix(h, to, t) {
    var c = hex(h), out = '#';
    for (var i = 0; i < 3; i++) { var v = Math.round(c[i] + (to - c[i]) * t); out += ('0' + v.toString(16)).slice(-2); }
    return out;
  }
  function colorsOf(name) {
    var out = [];
    name.toLowerCase().split(/&|,|\/|\band\b|\bwith\b|\+/).forEach(function (part) {
      var words = part.trim().split(/\s+/), found = null;
      words.forEach(function (w) { if (!found && MAP[w]) found = MAP[w]; });
      if (!found) return;
      if (words.indexOf('dark') > -1) found = mix(found, 0, 0.35);
      if (words.indexOf('light') > -1 || words.indexOf('pale') > -1 || words.indexOf('dusty') > -1) found = mix(found, 255, 0.35);
      out.push(found);
    });
    return out.slice(0, 2);
  }
  function paint() {
    document.querySelectorAll('.albeux-swatch:not([data-ready])').forEach(function (s) {
      var c = colorsOf(s.getAttribute('data-color') || '');
      if (!c.length) c = ['#8c8c8c'];
      var bg;
      if (c.length === 1) bg = c[0];
      else bg = 'linear-gradient(90deg,' + c[0] + ' 50%,' + c[1] + ' 50%)';
      s.style.background = bg;
      s.setAttribute('data-ready', '1');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.albeux-swatch');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var card = b.closest('.product-grid__item') || b.closest('[class*="product-card"]');
    if (!card) return;
    card.querySelectorAll('.albeux-swatch').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    var img = card.querySelector('img');
    var url = b.getAttribute('data-image');
    if (!img || !url) return;
    var pre = new Image();
    img.style.transition = 'opacity .25s ease';
    img.style.opacity = '0.2';
    pre.onload = function () {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = url;
      img.style.opacity = '1';
    };
    pre.onerror = function () { img.style.opacity = '1'; };
    pre.src = url;
  }, true);
  function init() { paint(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; paint(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();